<template>
  <section class="banner__two slider-two position-relative">
    <div class="pattern-layer">
      <div
        class="pattern-1 position-absolute"
        data-parallax='{"x": 100}'
        :style="`background-image: url('${patternImage}')`"
      ></div>
    </div>
    <div class="image-layer position-absolute" :style="`background-image: url('${backgroundImage}')`"></div>
    
    <div class="banner__data__two position-relative">
      <div class="banner-carousel owl-theme owl-carousel owl-dots-none">
        <div 
          v-for="(slide, index) in slides" 
          :key="index"
          class="slide-item position-relative"
        >
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <div class="content-box position-relative">
                  <div class="sub__title">
                    <h4 class="position-relative">
                      <span class="slider-text-anim two">{{ slide.subtitle }}</span>
                    </h4>
                  </div>
                  <h2 class="position-relative">
                    <span 
                      v-for="(titleLine, titleIndex) in slide.titleLines" 
                      :key="titleIndex"
                      class="slider-text-anim"
                      :class="{ 'title__last': titleIndex === slide.titleLines.length - 1 }"
                    >
                      {{ titleLine.text }}
                      <span v-if="titleLine.highlight">{{ titleLine.highlight }}</span>
                    </span>
                  </h2>
                  <p>{{ slide.description }}</p>
                  <div class="btn-box">
                    <router-link
                      :to="slide.buttonLink"
                      class="theme-btn theme-btn-one"
                    >
                      <i class="icon-02"></i> {{ slide.buttonText }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner__bottom">
        <div class="row">
          <div class="col-lg-6 col-md-12"></div>
          <div class="col-lg-6 col-md-12">
            <div class="banner__mission__block flex-wrap flex-md-nowrap">
              <div class="mission__block">
                <h3>{{ missionVision.vision.title }}</h3>
                <p>{{ missionVision.vision.description }}</p>
              </div>
              <div class="mission__block">
                <h3>{{ missionVision.mission.title }}</h3>
                <p>{{ missionVision.mission.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted } from "vue";

export default {
  name: "ServicesCarouselComp",
  props: {
    slides: {
      type: Array,
      required: true,
      default: () => []
    },
    backgroundImage: {
      type: String,
      default: '/resource/portfolio-04.jpg'
    },
    patternImage: {
      type: String,
      default: '/shapes/shape-06.png'
    },
    missionVision: {
      type: Object,
      required: true,
      default: () => ({
        vision: { title: 'Our Vision', description: 'Default vision description' },
        mission: { title: 'Our Mission', description: 'Default mission description' }
      })
    }
  },
  setup() {
    onMounted(async () => {
      // Import and initialize Owl Carousel
      try {
        await import("owl.carousel");

        // Initialize Owl Carousel for banner
        setTimeout(() => {
          if (window.$ && window.$.fn.owlCarousel) {
            window.$(".banner-carousel").owlCarousel({
              loop: true,
              margin: 0,
              nav: true,
              active: true,
              smartSpeed: 1000,
              autoplay: 6000,
              navText: [
                '<span class="icon-05"></span>',
                '<span class="icon-06"></span>',
              ],
              responsive: {
                0: {
                  items: 1,
                },
                600: {
                  items: 1,
                },
                768: {
                  items: 1,
                },
                992: {
                  items: 1,
                },
                1200: {
                  items: 1,
                },
              },
            });
          }
        }, 100);
      } catch (error) {
        console.error("Error loading Owl Carousel:", error);
      }
    });
  },
};
</script>

<style scoped>
/* Services Carousel Specific Styles */
.banner__two {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  background: #000 !important;
  overflow: hidden;
}

.banner__two .auto-container {
  padding-top: 100px !important;
  padding-bottom: 0px !important;
}

.banner__two .content-box {
  padding-bottom: 60px !important;
}

/* Custom button styling for services carousel */
.banner__two .btn-box .theme-btn {
  padding: 12px 30px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  border-radius: 0 !important;
  background: linear-gradient(219deg, #FB0E76 0%, #910694 100%) !important;
  color: #fff !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  border: none !important;
  position: relative !important;
  overflow: hidden !important;
  transition: all 0.3s ease !important;
}

.banner__two .btn-box .theme-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.banner__two .btn-box .theme-btn:hover::before {
  left: 100%;
}

.banner__two .btn-box .theme-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 5px 15px rgba(251, 14, 118, 0.4) !important;
  color: #fff !important;
  text-decoration: none !important;
}

.banner__two .btn-box .theme-btn i {
  font-size: 12px !important;
  transition: transform 0.3s ease !important;
}

.banner__two .btn-box .theme-btn:hover i {
  transform: translateX(3px) !important;
}

/* Banner Bottom */
.banner__bottom {
  margin-top: 40px;
}

.banner__mission__block {
  border-radius: 0;
  padding: 0;
}

.mission__block {
  padding: 40px 50px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.mission__block:last-child {
  border-right: none;
}

.mission__block h3 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  font-family: "Archivo", sans-serif;
}

.mission__block p {
  color: #ccc;
  font-size: 14px;
  line-height: 24px;
  margin: 0;
  font-family: "Open Sans", sans-serif;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .banner__two .content-box h2 {
    font-size: 50px !important;
    line-height: 60px !important;
  }
  
  .mission__block {
    padding: 30px 25px !important;
  }
  
  .mission__block h3 {
    font-size: 18px !important;
  }
  
  .mission__block p {
    font-size: 13px !important;
    line-height: 22px !important;
  }
}

/* Import Flaticon */
@import "@/assets/scss/Flaticon.scss";
</style>
